import cn from "classnames";
import {
  startOfWeek,
  endOfWeek,
  startOfMonth,
  addWeeks,
  eachDayOfInterval,
  isToday,
  isSameMonth,
  format,
  isSameDay,
} from "date-fns";

import { Text } from "@/components/Text";

import styles from "./CalendarDays.module.scss";

interface CalendarDaysProps {
  currentDate: Date;
  onDayChange: (day: Date) => void;
}

export const CalendarDays = ({
  currentDate,
  onDayChange,
}: CalendarDaysProps): React.JSX.Element | null => {
  const weekDays = eachDayOfInterval({
    start: startOfWeek(currentDate),
    end: endOfWeek(currentDate),
  }).map((date) => format(date, "EEEEE"));

  const startOfMonthDate = startOfMonth(currentDate);
  const startDate = startOfWeek(startOfMonthDate);
  const endDate = endOfWeek(addWeeks(startDate, 5));

  const days = eachDayOfInterval({
    start: startDate,
    end: endDate,
  });

  const getDayClasses = (day: Date) => {
    return cn(styles.day, {
      [styles.today]: isToday(day),
      [styles["same-day"]]: isSameDay(day, currentDate),
      [styles["same-month"]]: isSameMonth(day, currentDate),
    });
  };

  return (
    <div className={styles["container"]}>
      {weekDays.map((day, i) => (
        <div key={i} className={styles["week-day"]}>
          <Text variant="text-2-medium">{day}</Text>
        </div>
      ))}

      {days.map((day, i) => (
        <div
          className={getDayClasses(day)}
          key={i}
          onClick={() => onDayChange(day)}
        >
          <Text variant="text-2-medium">{format(day, "dd")}</Text>
        </div>
      ))}
    </div>
  );
};
